export default {
  AVAILABLE: 0,
  RESERVE: 1,
  DISBURSE: 2,
  EXPIRE: 3,
  USED: 4,
  TRANSFER: 5
}
